module.exports = __webpack_public_path__ + "static/media/icons-ic-call-stroke.5fdd16b8.svg";